import type { Task } from '~/redux/api/methods/k2/listTasks';
import { ServiceRequestConfig } from '~/services/createService';
import { k2 } from '~/services/serviceInstances';

import { GetTaskApiResponse } from '../../types/k2/ticketTasks';

type Request = {
  ticketId: string;
  taskId: string;
};
type ServerResponse = GetTaskApiResponse;

export const getTaskK2 = async (
  request: Request,
  options: ServiceRequestConfig = {},
): Promise<Task> => {
  const serverResponse: ServerResponse = await k2.get(
    `/tickets/${request.ticketId}/tasks/${request.taskId}`,
    { showErrorToast: true, ...options },
  );

  return mapResponse(serverResponse);
};

const mapResponse = (serverResponse: ServerResponse): Task => {
  return {
    id: serverResponse.data.id,
    ...serverResponse.data.attributes,
  };
};
